export default __webpack_public_path__ + "static/media/invite-client.b012feaf.svg";